<template>
  <iframe
    ref="frame"
    class="chatwoot-teste-frame"
    :src="url"
    title="Conversa de teste do fluxo"
    @load="enviarConfiguracao"
  />
</template>

<script>
export default {
  props: {
    contaId: { type: [Number, String], required: true },
    fluxoId: { type: [Number, String], required: true }
  },
  data() {
    return { url: `${process.env.BASE_URL}fluxo-chatwoot-teste.html` };
  },
  mounted() {
    window.addEventListener("message", this.receberMensagem);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.receberMensagem);
  },
  methods: {
    enviarConfiguracao() {
      this.$refs.frame?.contentWindow?.postMessage(
        {
          type: "fluxo-teste:iniciar",
          conta_id: this.contaId,
          fluxo_id: this.fluxoId
        },
        window.location.origin
      );
    },
    receberMensagem(event) {
      if (
        event.origin !== window.location.origin ||
        event.source !== this.$refs.frame?.contentWindow
      )
        return;
      if (event.data?.type === "fluxo-teste:pronto") this.$emit("ready");
      if (event.data?.type === "fluxo-teste:fechado") this.$emit("close");
      if (event.data?.type === "fluxo-teste:erro") this.$emit("error");
    }
  }
};
</script>

<style scoped>
.chatwoot-teste-frame {
  border: 0;
  display: block;
  flex: 1;
  height: 100%;
  min-height: 0;
  width: 100%;
}
</style>
